import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchComments } from "../../../../actions/mods_factory/commentsActions";
import { queryParams } from "../../../../helpers/UrlHelpers";

import Pagination from "../../../../componets/Pagination";
import Card from "../../../../componets/Card";
import CommentsList from "../../Comments/_partials/_List";
import useGoToComment from "../../../../hooks/useGoToComment";

const LIMIT = 20;

const _Comments = ({ addonTemplateId }: { addonTemplateId: number | undefined }) => {
  const dispatch        = useAppDispatch();
  const isRedirect      = useGoToComment({ limit: LIMIT });
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const count           = useAppSelector(state => state.modsFactory.comments.count);

  useEffect(() => {
    if (!addonTemplateId || isRedirect) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT,
      addon_template_id: addonTemplateId
    };

    dispatch(fetchComments(params))
  }, [addonTemplateId, currentPage, dispatch, isRedirect])

  return (
    <Card>
      <h4 className='v-content-title'>Comments</h4>

      {isRedirect ?
        <div>Redirecting...</div> :
        <CommentsList />
      }

      <Pagination total={count} size={LIMIT} />
    </Card>
  )
}

export default _Comments;
